import { atom } from "recoil";

export const isSavingWizardAtom = atom<boolean>({
  key: "isSavingWizardAtom",
  default: false,
});
